<script lang="ts">
  import clsx from 'clsx'
  import componentAttributesStore from '../../../stores/componentAttributes.svelte'
  import translationsStore from '../../../stores/translations.svelte'
  import videoStore from '../../../stores/video.svelte'
  import MuteIcon from '../icons/MuteIcon.svelte'
  import VolumeHighIcon from '../icons/VolumeHighIcon.svelte'
  import VolumeLowIcon from '../icons/VolumeLowIcon.svelte'
  import ControlBarButton from './ControlBarButton.svelte'
  import { THEMES, COLORS } from '../../../const/themes'

  let hover = $state(false)

  let value = $state(0)

  $effect(() => {
    const muted = componentAttributesStore.state.muted
    const volume = componentAttributesStore.state.volume
    value = muted || volume <= 0 ? 0 : volume
  })
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<!-- svelte-ignore a11y_mouse_events_have_key_events -->
<div
  onmouseover={() => (hover = true)}
  onmouseleave={() => (hover = false)}
  class="group flex h-full items-center hover mobile:aspect-square"
>
  <ControlBarButton
    color={hover
      ? componentAttributesStore.state.buttonsHoverColor ||
        componentAttributesStore.state.primaryColor ||
        THEMES.DEFAULT.BUTTONS_HOVER_COLOR
      : undefined}
    onclick={() => videoStore.state.videoController?.toggleMute()}
    tooltip={componentAttributesStore.state.muted
      ? translationsStore.state.unmute
      : translationsStore.state.mute}
  >
    {#if componentAttributesStore.state.muted || componentAttributesStore.state.volume === 0}
      <MuteIcon />
    {:else if componentAttributesStore.state.volume <= 0.5}
      <span class="relative -left-[2.5px]">
        <VolumeLowIcon />
      </span>
    {:else}
      <VolumeHighIcon />
    {/if}
  </ControlBarButton>
  <div
    class="h-3 w-20 relative px-2 hidden group-hover:block mobile:hidden mobile:group-hover:hidden"
  >
    <input
      class={clsx(
        'absolute top-0 left-0 appearance-none focus:outline-none w-full h-full z-10 opacity-0 cursor-pointer',
      )}
      type="range"
      max="1"
      step=".01"
      {value}
      oninput={(e) =>
        videoStore.state.videoController?.setVolume(
          parseFloat(e.currentTarget.value),
        )}
    />
    <span class="block relative w-full h-full z-0">
      <span
        class="block w-full h-1 rounded-full overflow-hidden absolute left-0 top-1/2 -translate-y-1/2 z-0"
      >
        <span
          class="block w-full h-full left-0 top-0 opacity-50 z-0"
          style={`background-color: ${COLORS.MEDIUM}`}
        ></span>
        <span
          class="block absolute top-0 left-0 h-full z-10"
          style={`width: ${value * 100}%; background-color: ${componentAttributesStore.state.buttonsHoverColor || componentAttributesStore.state.primaryColor || THEMES.DEFAULT.BUTTONS_HOVER_COLOR};`}
        ></span>
      </span>
      <span
        class="block absolute w-3 h-3 top-1/2 -translate-y-1/2 z-10"
        style={`left: ${value * 100}%`}
      >
        <span
          class="block absolute top-0 -translate-x-1/2 w-full h-full rounded-full"
          style={`background-color: ${componentAttributesStore.state.buttonsHoverColor || componentAttributesStore.state.primaryColor || THEMES.DEFAULT.BUTTONS_HOVER_COLOR};`}
        ></span>
      </span>
    </span>
  </div>
</div>
